<template>
  <div
    id="data-list-thumb-view"
    class="data-list-container vs-con-loading__container"
  >
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="data"
      stripe
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="createItem"
          >
            <feather-icon
              icon="PlusIcon"
              svgClasses="h-4 w-4"
            />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ data.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : data.length }} of {{ data.length }}</span>
            <feather-icon
              icon="ChevronDownIcon"
              svgClasses="h-4 w-4"
            />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Category</vs-th>
        <vs-th>Listing</vs-th>
        <vs-th>Renewal</vs-th>
        <vs-th>Order</vs-th>
        <vs-th>Status</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <p v-if="tr.category">{{ tr.category.nameId }}</p>
            </vs-td>
            <vs-td>
              <div class="flex" v-if="tr.business">
                <div class="mr-3">
                  <vs-avatar :src="tr.business.logoUrl" />
                </div>
                <div>
                  <p class="product-name font-medium">{{ tr.business.name }} #{{ tr.business.contractNumber }}</p>
                  <p class="product-name small">{{ tr.business.category.nameId }}</p>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <p>{{ formatDate(tr.dateRenewal) }} ({{ formatIDR(tr.priceRenewal) }})</p>
            </vs-td>
            <vs-td>
              {{ tr.order }}
            </vs-td>
            <vs-td>
              <status-chip :data="tr.status" />
            </vs-td>
            <vs-td>
              <div class="action-inline-group">
                <vs-button
                  color="dark"
                  type="flat"
                  icon="edit"
                  @click="editItem(tr.id, tr)"
                />
                <vs-button
                  color="danger"
                  type="flat"
                  icon="delete"
                  @click="confirmDelete(tr.id)"
                />
              </div>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <list-form
      :item-id="formData.id"
      :form-title="formData.title"
      :form-data="formData.data"
      :is-sidebar-active="formData.show"
      @closeSidebar="formData.show = false"
      @change="(data) => formData.data.business = data"
    />
  </div>
</template>


<script>
import ListForm from './ListForm'

export default {
  components: { ListForm },
  data () {
    return {
      itemsPerPage: 10,
      isMounted: false,
      formData: {
        show: false,
        title: '',
        id: null,
        data: {
          business: {}
        }
      },
      idForDeletion: null
    }
  },
  methods: {
    editItem (id, data) {
      data.order = parseInt(data.order)
      this.formData.show = true
      this.formData.data = data
      this.formData.id = id
      this.formData.title = 'Edit Top List'
    },
    createItem () {
      this.formData.show = true
      this.formData.data = {
        status: '',
        imageUrl: '',
        business: {},
        category: {},
        saler: {},
        owner: {},
        dateRegister: null,
        dateRenewal: null,
        price: 0,
        priceRenewal: 0,
        order: 0
      }
      this.formData.id = null
      this.formData.title = 'Add Top List'
    },
    confirmDelete (id) {
      this.idForDeletion = id
      this.showConfirmDeletion(this.deleteItem)
    },
    deleteItem () {
      this.$store.dispatch('toplist/delete', this.idForDeletion)
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    data: {
      get () {
        return this.$store.getters['toplist/arrayData']
      }
    }
  },
  mounted() {
    this.isMounted = true
  }
};
</script>


<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
